/*
 * Copyright (c) 2023-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {IdenticalConnectorPair} from "./IdenticalConnectorPair.model";

export class GMIdenticalConnectorResultsHolder {
  allIdenticalConnectorPairs = new Array<IdenticalConnectorPair>;
  resultCode: boolean;

  constructor() {
  }
}
